/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import can from 'can';
import template from './strokes-gained.stache';

const strokesMapping = [
    {
        title: 'Strokes Gained Off the Tee',
        identifier: 'offTheTee',
    },
    {
        title: 'Strokes Gained Approach',
        identifier: 'approach',
    },
    {
        title: 'Strokes Gained Short Game',
        identifier: 'shortGame',
    },
    {
        title: 'Strokes Gained Putting',
        identifier: 'putting',
    },
];

const statisticsSettings = window.globalSettings.statisticsSettings;

Component.extend({
    tag: 'leaderboard-strokes-gained',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            round: {
                type: 'number',
                value: 1,
            },
            roundInfo: {
                get() {
                    const round = this.attr('round');
                    const currentCategory = this.attr('category');
                    const categoryFilter = (roundStat) =>
                        roundStat.name === currentCategory ||
                        roundStat.name === `Strokes Gained ${currentCategory}`;

                    if (round) {
                        const stats = this.attr(
                            `player.roundsInfo.${round - 1}.strokeGainedStats`,
                        );
                        return stats
                            ? stats.serialize().find(categoryFilter)
                            : null;
                    } else {
                        const overallStats = this.attr(
                            'player.strokeGainedOverallStats',
                        );
                        return overallStats
                            ? overallStats.serialize().find(categoryFilter)
                            : null;
                    }
                },
            },
            category: {
                type: 'string',
                value: '',
            },
            player: {
                Type: can.Map,
            },
            title: {
                type: 'string',
                get() {
                    const roundInfo = this.attr('roundInfo');
                    return (
                        (roundInfo && roundInfo.name) ||
                        this.attr('category') ||
                        ''
                    );
                },
            },
            rank: {
                type: 'string',
                get() {
                    const roundInfo = this.attr('roundInfo');
                    return (roundInfo && roundInfo.rank) || '';
                },
            },
            value: {
                type: 'string',
                get() {
                    const roundInfo = this.attr('roundInfo');
                    if (roundInfo && roundInfo.stat) {
                        const stat = roundInfo.stat;
                        const valuePrefix = stat.value > 0 ? '+' : '';
                        return `${valuePrefix}${stat.displayValue}`;
                    }
                },
            },
        },
        getInfoTitle() {
            return `${this.attr('title')}`.toUpperCase();
        },
        getSubTitle() {
            return this.attr('title') &&
                this.attr('title').includes('Strokes Gained ')
                ? this.attr('title').replace('Strokes Gained ', '')
                : this.attr('title');
        },
        getInfoText() {
            const title = this.attr('title');
            const infoMapping = strokesMapping.find(
                (info) => info.title.replace('Strokes Gained ', '') === title,
            );

            if (infoMapping) {
                return statisticsSettings[infoMapping.identifier];
            } else {
                let description = this.attr('roundInfo').description;
                if (description && description.includes(':| ')) {
                    return can.capitalize(description.split(':| ')[1]) || '';
                }
                return description || '';
            }
        },
    },
    events: {},
});
